module.exports = __webpack_public_path__ + "static/info-arch-89c5c5b1dfffd7015edbf8e078b2752a.png";